import React from 'react';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import Copyright from './furniture/Copyright'
import {useStyles}from './furniture/Dashboard-Config'
import AppBarAndDrawer from './furniture/AppBarAndDrawer'

import { useOvermind } from '../overmind';
import NewSessionLoader from './accountSelection/NewSessionLoader'

export default function Utilization() {
  const classes = useStyles();
  const { state, actions } = useOvermind();

  if(state.blockAccess){
    actions.updateFlag({'name':'redirectPath','payload':'/alerts'});
    return(<NewSessionLoader/>);
  }else{
    return (
      <div className={classes.root}>
        <AppBarAndDrawer/>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <Grid container spacing={2}>

            {/* Placeholder */}
            <Grid item xs={12} md={8} lg={12}>
            <Paper className={classes.paper}>
              <Typography component="h2" variant="h6" color="primary" gutterBottom >
                Alerts
              </Typography>
              <Typography component="body1" variant="body1"  gutterBottom >
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
              </Typography>
            </Paper>
            </Grid>

            {/* Explore Graph*/}
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                hello world
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
              <div>
                <Button variant="contained" size="large" color="primary" className={classes.margin}>
                    Create an Alert
                </Button>
              </div>
                List of Alerts that have been setup
                <p>or</p>
                Image encouring user to setup an alert!
              </Paper>
            </Grid>


            </Grid>
            <Box pt={4}>
              <Copyright />
            </Box>
          </Container>
        </main>
      </div>
    );
  }
}
